import { useBoolean } from '@dreryk/react-common';

import { AppointmentNoteManagementModal } from './AppointmentNoteManagementModal';

type AppointmentNoteManagementModalOpenerRenderProps = { openModal: VoidFunction };

type AppointmentNoteManagementModalOpenerProps = {
   readonly appointmentId: number;
   readonly appointmentNote?: string;
   readonly onAppointmentNoteUpdated: VoidFunction;
   readonly children: (renderProps: AppointmentNoteManagementModalOpenerRenderProps) => JSX.Element;
};

export const AppointmentNoteManagementModalOpener = (props: AppointmentNoteManagementModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   const handleSuccess = (): void => {
      props.onAppointmentNoteUpdated();
      closeModal();
   };

   return (
      <>
         {props.children({ openModal: openModal })}

         {modalOpened ? (
            <AppointmentNoteManagementModal
               appointmentId={props.appointmentId}
               appointmentNote={props.appointmentNote}
               onSuccess={handleSuccess}
               onClose={closeModal}
            />
         ) : null}
      </>
   );
};
